import type {
  GetUsersParamsType,
  GetUsersResponseType,
} from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { trashKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useGetTrashedUsers({
  direction = "desc",
  itemsPerPage = 25,
  page = 1,
  search,
  sortBy = "deletedAt",
}: Partial<GetUsersParamsType>) {
  return useQuery<GetUsersResponseType>({
    queryFn: async () => {
      const params = new URLSearchParams({
        direction,
        itemsPerPage: itemsPerPage.toString(),
        onlyTrashed: "true",
        page: page.toString(),
        sortBy,
      });

      if (search) {
        params.append("search", search);
      }

      return await apiClient.url(`/users?${params.toString()}`).get().json();
    },
    queryKey: trashKeys.users({
      direction,
      itemsPerPage,
      page,
      search,
      sortBy,
    }),
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  });
}
